import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import { ApplyOcSubscriptionsApiResultModel, applyOcSubscriptionsService } from "@WhiteCap/Store/Service/OsnSubscriptionsServices/OrderCompleteSubscribersService";

export interface ApplyOcSubscriptionsApiParameter extends ApiParameter {
    customerId: string;
    subscribedEmails: SubscribedEmailDto[];
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<ApplyOcSubscriptionsApiParameter, ApplyOcSubscriptionsApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/OcSubscriptions/BeginApplyOcSubscriptions",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await applyOcSubscriptionsService(
        props.apiParameter.customerId,
        props.apiParameter.subscribedEmails,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/OcSubscriptions/ApplyOcSubscriptionsError",
        });
        return false;
    }
};

export const DispatchCompleteApplyOcSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/OcSubscriptions/CompleteApplyOcSubscriptions",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplyOcSubscriptions];

const applyOcSubscriptions = createHandlerChainRunner(chain, "ApplyOcSubscriptions");
export default applyOcSubscriptions;
